import { HttpEvent } from "@angular/common/http";
import { MonoTypeOperatorFunction } from "rxjs";

export abstract class HttpEventsInterceptor {
    abstract readonly intercept: <T extends any = any>(requestInfo?: { body: any, params: any, url: string }) => MonoTypeOperatorFunction<HttpEvent<T>>
}